import { Checkbox } from 'antd'
import { CheckboxProps } from 'antd/lib'

import { useStyles } from './AnswerCard/styles'

type Props = {
  isSelected?: boolean
} & CheckboxProps

export const CustomCheckBox = ({ isSelected, ...props }: Props) => {
  const { styles } = useStyles({ isSelected })

  return <Checkbox rootClassName={styles.customCheckbox} {...props} />
}
